/* Carrito flotante móvil - sticky-cart.js */
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 749) {
    const buyButton = document.querySelector('.product-form__buttons .button--full-width');
    if (!buyButton) return;

    const sticky = document.createElement('button');
    sticky.textContent = 'Agregar al carrito';
    sticky.style.cssText = [
      'position:fixed',
      'bottom:1rem',
      'left:1rem',
      'right:1rem',
      'width:calc(100% - 2rem)',
      'z-index:9999',
      'display:none',
      'background-color:#000',
      'color:#fff',
      'border:none',
      'border-radius:4px',
      'font-size:15px',
      'font-family:inherit',
      'padding:16px',
      'cursor:pointer',
      'box-sizing:border-box'
    ].join(';');

    document.body.appendChild(sticky);

    sticky.addEventListener('click', function() {
      buyButton.click();
    });

    function checkVisibility() {
      const rect = buyButton.getBoundingClientRect();
      // Mostrar sticky solo cuando el botón original está AÚN por debajo de la pantalla
      sticky.style.display = rect.top > window.innerHeight ? 'block' : 'none';
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility();
  }
});

/* Pipoca · botón "Añadir al carrito" del upsell antiguo (bloques Liquid personalizado
   con onclick="pipocaAddBundle(this, 'ID')"). La función no existía en el tema. */
if (typeof window.pipocaAddBundle !== 'function') {
  window.pipocaAddBundle = function (btn, productId) {
    if (!btn || btn.disabled) return;
    var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
    var T = {
      es: ['Añadido ✓', 'No se pudo añadir. Inténtalo de nuevo.'],
      pt: ['Adicionado ✓', 'Não foi possível adicionar.'],
      en: ['Added ✓', "Couldn't add it. Please try again."],
      fr: ['Ajouté ✓', "Impossible d'ajouter. Réessayez."],
      de: ['Hinzugefügt ✓', 'Konnte nicht hinzugefügt werden.']
    }[lang] || ['Añadido ✓', 'No se pudo añadir. Inténtalo de nuevo.'];
    var input = document.getElementById('upsell-variant-' + productId);
    var fb = document.getElementById('upsell-feedback-' + productId);
    var variantId = input && input.value;
    if (!variantId) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('loading');
    if (fb) { fb.className = 'pipoca-upsell__feedback'; fb.textContent = ''; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        btn.classList.remove('loading');
        btn.classList.add('success');
        btn.textContent = T[0];
        var it = (d.items && d.items[0]) || {};
        document.dispatchEvent(new CustomEvent('pipoca:added-to-cart', { bubbles: true, detail: {
          productHandle: it.handle || '', productName: it.product_title || '',
          productPrice: '', productImg: it.image || '', upsellHandles: []
        } }));
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        setTimeout(function () {
          btn.classList.remove('success');
          btn.innerHTML = original;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        btn.classList.remove('loading');
        btn.disabled = false;
        if (fb) {
          fb.textContent = (err && (err.description || err.message)) || T[1];
          fb.className = 'pipoca-upsell__feedback show err';
        }
      });
  };
}